import React, { useContext, useEffect, useState } from 'react'
import { Paper, Collapse, useTheme } from '@mui/material'
import clsx from 'clsx'
import MenuList from '@mui/material/MenuList'
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import MenuIcon from '@mui/icons-material/Menu'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import TimelineIcon from '@mui/icons-material/Timeline'
import AnnouncementIcon from '@mui/icons-material/Announcement'
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn'
import CodeIcon from '@mui/icons-material/Code'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard'
import LogoutIcon from '@mui/icons-material/Logout'
import WatchLaterIcon from '@mui/icons-material/WatchLater'
import TuneIcon from '@mui/icons-material/Tune'
import CreateIcon from '@mui/icons-material/Create'
import PaymentIcon from '@mui/icons-material/Payment'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import hipersendService from '../services/hipersend'
import { ApiDataWrapperContext } from '../contexts/ApiDataWrapper'
import { AuthContext } from '../contexts/Auth'
import LinkWithQuery from '../components/LinkWithQuery'
import Text from '../components/Text'
import Logo from '../components/Logo'
import NewVersionAppModal from '../components/NewVersionAppModal'
import LinearProgressCustom from '../components/LinearProgressCustom'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { APP_VERSION } from '../services/appVersion'
import SidebarPreview from './SidebarPreview'

export default function LayoutMain({ children, showMainMenu = true }) {
  const { logout } = useContext(AuthContext)
  const { server, phone, provider, isLoading, getCredentials, statusSession, user } = useContext(ApiDataWrapperContext)
  const { api, secret } = getCredentials()
  const theme = useTheme()

  const [notifications, setNotifications] = useState([])
  const [showApiSecret, setShowApiSecret] = useState(false)
  const [isMenuMobileOpen, setIsMenuMobileOpen] = useState(false)

  const getNotifications = async () => {
    try {
      const notifications = await hipersendService.notificacoesInteligentes.getNotifications()
      setNotifications(notifications)
    } catch (error) {
      console.error(error)

      if(error?.response?.data?.error === 'Não foi possível encontrar a instância') {
        logout()
        return
      }
    }
  }

  useEffect(() => {
    getNotifications()
  }, [])

  if(!api || !secret) {
    return (
      <div className="h-full w-full flex justify-center items-center" style={{ backgroundColor: theme.palette.background.main }}>
        <Logo className="w-[150px]" />
      </div>
    )
  }

  return (
    <>
      <NewVersionAppModal />
      <div className="relative min-h-full flex" style={{ backgroundColor: theme.palette.background.main }}>
        <div
          className={clsx('h-full z-[999]', {
            'xl:block': showMainMenu,
            hidden: !isMenuMobileOpen || !showMainMenu,
            fixed: isMenuMobileOpen && showMainMenu
          })}
        >
          <div className="w-[300px]">
            <aside className="fixed z-[9000] top-0 left-0 w-[300px] h-full shadow-[5px_0px_10px_0px_rgba(0,0,0,0.3)]">
              <Paper square elevation={0} style={{ height: "100%", overflowY: "scroll" }}>
                {theme.isPreview ? (
                  <SidebarPreview
                    showMobileClose={isMenuMobileOpen && showMainMenu}
                    onCloseMobile={() => setIsMenuMobileOpen(false)}
                  />
                ) : (
                <div className="min-h-screen w-full pt-4 flex flex-col pb-8">
                  <div className="mb-4 px-4">
                    <div className="flex justify-between">
                      <Logo className="w-[150px]" />
                      {
                        isMenuMobileOpen && showMainMenu &&
                        <button onClick={() => setIsMenuMobileOpen(false)}>
                          <Text component="span">
                            <KeyboardArrowLeftIcon style={{ fontSize: 25 }} />
                          </Text>
                        </button>
                      }
                    </div>
                    <p className="text-sm">Notificações Inteligentes</p>
                    <p className="font-light text-xs opacity-[0.5]">Painel v{ APP_VERSION }</p>
                  </div>
                  <div className="relative">
                    <div className="absolute top-0 left-0 w-full">
                      <Collapse in={isLoading} timeout="auto" unmountOnExit>
                        <LinearProgressCustom />
                      </Collapse>
                    </div>
                    <div className={clsx('px-3 py-5 rounded bg-gray-300 space-y-2', {
                      'bg-opacity-[0.1]': theme.isDark,
                      'bg-opacity-[0.3]': !theme.isDark
                    })}>
                      <div>
                        <Text className="font-light text-sm">
                          MINHA API
                        </Text>
                        <Text>
                          {api}
                        </Text>
                      </div>
                      <div>
                        <Text className="font-light text-sm">
                          SECRET
                        </Text>
                        <div className="flex items-center space-x-2">
                          <Text className="relative">
                            <span style={{ opacity: showApiSecret ? 1 : 0 }} className="h-[20px] block">
                              {secret}
                            </span>
                            {
                              !showApiSecret &&
                              <span className="absolute left-0 -translate-y-1/2 top-1/2 w-full h-[15px] bg-gray-500 bg-opacity-50" />
                            }
                          </Text>
                          <button onClick={() => setShowApiSecret(!showApiSecret)}>
                            {
                              showApiSecret
                              ? <VisibilityOffIcon />
                              : <VisibilityIcon />
                            }
                          </button>
                        </div>
                      </div>
                      <div>
                        <Text className="font-light text-sm">
                          PHONE
                        </Text>
                        <Text className="h-[20px] relative">
                          {phone || <span className="absolute left-0 -translate-y-1/2 top-1/2 w-[120px] h-[15px] bg-gray-500 bg-opacity-[0.2]" />}
                        </Text>
                      </div>
                      <div>
                        <Text className="font-light text-sm">
                          VERSÃO
                        </Text>
                        <Text className="h-[20px] relative">
                          {provider || <span className="absolute left-0 -translate-y-1/2 top-1/2 w-[80px] h-[15px] bg-gray-500 bg-opacity-[0.2]" />}
                        </Text>
                        <Collapse in={['hiperapi-v3-cloud-official'].includes(provider)} timeout="auto" unmountOnExit>
                          <div className="flex items-center space-x-2">
                            <CheckCircleIcon style={{ color: theme.palette.primary.main, fontSize: 25 }} />
                            <Text className="font-black" style={{ color: theme.palette.primary.main }}>Meta Cloud API Oficial</Text>
                          </div>
                        </Collapse>
                      </div>
                      <div>
                        <Text className="font-light text-sm">
                          SERVIDOR
                        </Text>
                        <div className="h-[25px] relative">
                          {
                            server
                            ?
                            <Text>
                              Servidor {server}
                            </Text>
                            :
                            <span className="absolute left-0 -translate-y-1/2 top-1/2 w-[120px] h-[15px] bg-gray-500 bg-opacity-[0.2]" />
                          }
                        </div>
                      </div>
                      <div>
                        <Text className="font-light text-sm">
                          STATUS DA INTEGRAÇÃO
                        </Text>
                        <div className="h-[25px] relative">
                          {
                            statusSession === 'isLogged'
                            ?
                              <div className="flex items-center space-x-2">
                                <CheckCircleIcon style={{ color: theme.palette.primary.main }} />
                                <Text className="font-black" style={{ color: theme.palette.primary.main }}>CONECTADO</Text>
                              </div>
                            :
                            statusSession === 'notLogged'
                            ?
                              <div className="flex items-center space-x-2">
                                <DoNotDisturbOnIcon />
                                <Text className="font-medium">DESCONECTADO</Text>
                              </div>
                            :
                            <span className="absolute left-0 -translate-y-1/2 top-1/2 w-[120px] h-[15px] bg-gray-500 bg-opacity-[0.2]" />
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <MenuList>
                    <MenuItem component={LinkWithQuery} to="/">
                      <ListItemIcon>
                        <SpaceDashboardIcon fontSize="medium" />
                      </ListItemIcon>
                      <ListItemText className="py-3">
                        <Text className="font-medium">
                          Home
                        </Text>
                      </ListItemText>
                    </MenuItem>
                    <MenuItem component={LinkWithQuery} to="/messages/send">
                      <ListItemIcon>
                        <CreateIcon fontSize="medium" />
                      </ListItemIcon>
                      <ListItemText className="py-3">
                        <Text className="font-medium">
                          Enviar
                        </Text>
                      </ListItemText>
                    </MenuItem>
                    <MenuItem component={LinkWithQuery} to="/reports">
                      <ListItemIcon>
                        <TimelineIcon fontSize="medium" />
                      </ListItemIcon>
                      <ListItemText className="py-3">
                        <Text className="font-medium">
                          Relatórios
                        </Text>
                      </ListItemText>
                    </MenuItem>
                    <MenuItem component={LinkWithQuery} to="/messages/scheduler">
                      <ListItemIcon>
                        <WatchLaterIcon fontSize="medium" />
                      </ListItemIcon>
                      <ListItemText className="py-3">
                        <Text className="font-medium">
                          Expediente de envios
                        </Text>
                      </ListItemText>
                    </MenuItem>
                    {user?.plan?.functionalities?.includes('HiperPay') && (
                    <MenuItem component={LinkWithQuery} to="/hiperpay/profiles">
                      <ListItemIcon>
                        <PaymentIcon fontSize="medium" />
                      </ListItemIcon>
                      <ListItemText className="py-3">
                        <Text className="font-medium">
                          HiperPay
                        </Text>
                      </ListItemText>
                    </MenuItem>
                    )}
                    {user?.plan?.functionalities?.includes('SmartFilter') && (
                    <MenuItem component={LinkWithQuery} to="/smart-filter">
                      <ListItemIcon>
                        <FilterAltIcon fontSize="medium" />
                      </ListItemIcon>
                      <ListItemText className="py-3">
                        <Text className="font-medium">
                          SmartFilter
                        </Text>
                      </ListItemText>
                    </MenuItem>
                    )}
                    <MenuItem component={LinkWithQuery} to="/settings">
                      <ListItemIcon>
                        <TuneIcon fontSize="medium" />
                      </ListItemIcon>
                      <ListItemText className="py-3">
                        <Text className="font-medium">
                          Configurações
                        </Text>
                      </ListItemText>
                    </MenuItem>
                    <MenuItem component={LinkWithQuery} to="/documentation">
                      <ListItemIcon>
                        <CodeIcon fontSize="medium" />
                      </ListItemIcon>
                      <ListItemText className="py-3">
                        <div className="flex items-center space-x-2">
                          <Text className="font-medium">
                            Documentação
                          </Text>
                          <span className="font-black text-xs" style={{ color: theme.palette.primary.main }}>NOVIDADES</span>
                        </div>
                      </ListItemText>
                    </MenuItem>
                    <MenuItem component={LinkWithQuery} to="/changelog">
                      <ListItemIcon>
                        <AccountTreeIcon fontSize="medium" />
                      </ListItemIcon>
                      <ListItemText className="py-3">
                        <div className="flex items-center space-x-2">
                          <Text className="font-medium">
                            Changelog
                          </Text>
                          <span className="font-black text-xs" style={{ color: theme.palette.primary.main }}>v{APP_VERSION}</span>
                        </div>
                      </ListItemText>
                    </MenuItem>
                    <MenuItem onClick={logout}>
                      <ListItemIcon>
                        <LogoutIcon fontSize="medium" />
                      </ListItemIcon>
                      <ListItemText className="py-3">
                        <Text className="font-medium">
                          Sair
                        </Text>
                      </ListItemText>
                    </MenuItem>
                  </MenuList>
                  {/* <div className="mt-16 px-5">
                    <p>Detalhes da API</p>
                    <div className="space-y-3 mt-4">
                      <div>
                        <p className="text-xs font-light">API</p>
                        <p className="font-medium">{api}</p>
                      </div>
                      <div>
                        <p className="text-xs font-light">SECRET</p>
                        <p className="font-medium">{secret}</p>
                      </div>
                      <div>
                        <p className="text-xs font-light">SERVIDOR</p>
                        <p className="font-medium">servidor {server}</p>
                      </div>
                      <div>
                        <p className="text-xs font-light">TELEFONE</p>
                        <p className="font-medium">{phone}</p>
                      </div>
                      <div>
                        <p className="text-xs font-light">STATUS</p>
                        <p className="font-bold">
                          {
                            isSuspended === undefined
                            ? '-'
                            : isSuspended
                              ? 'DESATIVADO'
                              : 'ATIVADO'
                          }
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
                )}
              </Paper>
            </aside>
          </div>
        </div>
        <div className="w-full">
          <Collapse in={notifications.length > 0} timeout="auto" unmountOnExit>
            {
              notifications
                .filter(notifications => notifications.isActive)
                .map((notification, index) => (
                  <div key={index} className="p-12 bg-white bg-opacity-[0.1] rounded-sm">
                    <div className="flex space-x-4">
                      <AnnouncementIcon style={{ fontSize: 35 }} className="scale-x-[-1]" />
                      <div>
                        <Text className="font-black text-xl">{notification.title}</Text>
                        <Text>{notification.content}</Text>
                      </div>
                    </div>
                  </div>
              ))
            }
          </Collapse>
          {
            showMainMenu &&
            <header
              className="xl:hidden sticky top-0 z-[800] flex items-center justify-between px-4"
              style={{ height: 56, backgroundColor: theme.palette.background.paper, borderBottom: `1px solid ${theme.palette.divider}` }}
            >
              <Logo className="w-[120px]" />
              <button
                aria-label="Abrir menu"
                onClick={() => setIsMenuMobileOpen(true)}
                className="flex items-center justify-center"
                style={{ width: 40, height: 40, borderRadius: 10 }}
              >
                <MenuIcon style={{ fontSize: 26 }} />
              </button>
            </header>
          }
          {
            isMenuMobileOpen && showMainMenu &&
            <div
              className="xl:hidden fixed inset-0 z-[998]"
              style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
              onClick={() => setIsMenuMobileOpen(false)}
            />
          }
          {children}
        </div>
      </div>
    </>
  )
}
